
import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import ServiceHeader from "./ServiceHeader";
import Footer from "./Footer";
import ServiceOverallHealthKpi from "./ServiceOverallHealthKpi";
import ServiceNiagaraConnections from "./ServiceNiagaraConnections";
import ServiceDeviceConnections from "./ServiceDeviceConnections";
import ServiceNiagaraVersions from "./ServiceNiagaraVersions";
import ServiceTopFive from "./ServiceTopFive";
import ServiceSummaryTable from "./ServiceSummaryTable";



function ServiceApp({data}) {
    // console.log(data);

    function formatTime(utc) {
        // console.log(utc);
        let date = new Date(utc);
        let format = date.toUTCString();
        // console.log(format);
        return format;

    }


    // @ts-ignore
    return (
        <Container id="container" fluid className="h-100">
            <ServiceHeader location={data.general.location}></ServiceHeader>
            <Container id="content" fluid className="px-2">
                <Row>
                    <Col sm={3} className="px-0">
                        <ServiceOverallHealthKpi data={data.kpi}> </ServiceOverallHealthKpi>
                    </Col>
                    <Col sm={4} className="px-0">
                        <Row>
                            <Col>

                                <ServiceNiagaraConnections data={data.niagaraNetwork}></ServiceNiagaraConnections>

                            </Col>

                        </Row>
                        <Row>
                            <Col>
                                <ServiceDeviceConnections data={data.device}></ServiceDeviceConnections>
                            </Col>

                        </Row> <Row>
                        <Col>
                            <ServiceNiagaraVersions data={data.niagaraVersion}></ServiceNiagaraVersions>
                        </Col>

                    </Row>
                    </Col>
                    <Col sm={5} className="px-0">
                        <ServiceTopFive data={data.stationSummary}></ServiceTopFive>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="px-0">
                        <ServiceSummaryTable data={data.downStationSummary.concat(data.stationSummary)}></ServiceSummaryTable>
                    </Col>
                </Row>
            </Container>

            <Footer time={formatTime(data.general.currentTime)}></Footer>

        </Container>

    );
}

export default ServiceApp;
